import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addArticle } from '../../Redux/actions/homeAction';
import { stateList } from '../../Redux/actions/userAction';
import { getToken } from '../../Helper/Session';
import { inputPlaceHolders, isEmpty } from "../../Helper/Util";
import Header from '../Layout/Header';

class AddArticle extends Component {
    constructor(props) {
        super(props)
        this.state = {
            article_title: '',
            state: '',
            weburl: '',
            article_description: '',
            image: null,
            height: 0,
            width: 0,
            errors: {}
        }
    }

    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: ''
            }
        })
    }

    handleImgChange = (e) => {
        var file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            let images = e.target.result;
            this.setState({
                image: images.split(';base64')[1],
                errors: {
                    image: ''
                }
            });
        };
        reader.readAsDataURL(file);
    };

    componentDidMount() {
        const params = {
            apikey: process.env.REACT_APP_API_KEY,
        }
        this.props.stateList(params);
        inputPlaceHolders();
    }

    validate = () => {
        const { article_title, article_description, state, image } = this.state;
        let errors = {};
        if (isEmpty(article_title)) errors.article_title = true;
        if (isEmpty(article_description)) errors.article_description = true;
        if (image === null) errors.image = true;
        if (isEmpty(state)) errors.state = true;
        return errors;
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        const errors = this.validate();
        if (Object.keys(errors).length !== 0) {
            this.setState({ errors });
            return false;
        }
        const { home: { aCurrentPage } } = this.props;
        const params = {
            article_title: this.state.article_title,
            state: this.state.state,
            weburl: this.state.weburl,
            article_description: this.state.article_description,
            image: this.state.image,
            height: this.state.height,
            width: this.state.width,
            userid: token.id,
            apikey: process.env.REACT_APP_API_KEY
        }
        this.props.addArticle(params, this.props.history, token.admin, aCurrentPage);
    }

    render() {
        const { errors } = this.state;
        const { home: { states }, UI: { loading } } = this.props;
        let stateMarkup = states !== undefined && states.length > 0 ?
            states.map((result, i) => <option value={result.id} key={i}>{result.name}</option>) :
            <p>No Data</p>;
        return (
            <section className="main-Section">
                <form className="form-block formBox" onSubmit={this.handleSubmit}>
                    <Header
                        title={'Post'}
                        backUrl={'articles-legislation'}
                        saveBtn={true}
                        loading={loading}
                    />
                    <div className="container-fluid midSection scrollSection">
                        <div className="content">
                            <fieldset>
                                <span className="placeholder">Title</span>
                                <input type="text" name="article_title" className={`form-control input__field ${errors.article_title ? 'inputError' : ''}`} value={this.state.article_title} onChange={this.handleChange} />
                            </fieldset>
                            <fieldset className="selectInput redAro">
                                <span className="placeholder">State</span>
                                <select className={`form-control input__field ${errors.state ? 'inputError' : ''}`} name="state" value={this.state.state} onChange={this.handleChange}>
                                    <option value=''>Select State</option>
                                    {stateMarkup}
                                </select>
                            </fieldset>
                            <fieldset>
                                <span className="placeholder">Website (optional)</span>
                                <input type="text" name="weburl" className={`form-control input__field`} value={this.state.weburl} onChange={this.handleChange} />
                            </fieldset>
                            <fieldset className="input--filled">
                                <span className="placeholder">Description</span>
                                <textarea name="article_description" className={`form-control input__field ${errors.article_description ? 'inputError' : ''}`} value={this.state.article_description} onChange={this.handleChange} ></textarea>
                            </fieldset>
                            <div className="profileBrowse">
                                <div className="profileImage">
                                    <figure>
                                        <img src={this.state.image ? (`data:image/png;base64` + this.state.image) : "../images/profile-pic.png"} alt="Fig" />
                                    </figure>
                                    <label className="addProfile">
                                        <img src="../images/add.png" alt="User" />
                                        <input type="file" name="image" onChange={this.handleImgChange} />
                                    </label>
                                </div>
                                <div>
                                    <h4 className={`uplodError ${errors.image ? 'upload-title' : ''}`}>Please Upload Image</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        )
    }
}

const mapStateToProps = (state) => ({
    home: state.home,
    UI: state.UI
})

const mapActionToProps = {
    addArticle,
    stateList
}

export default connect(mapStateToProps, mapActionToProps)(AddArticle);